import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  TextField,
  Button,
  Typography,
  Select,
  MenuItem,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { OutlinedInput } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";


const DetailsDialog = ({ open, onClose, selectedRow, onSave }) => {
  const [creditThreshold, setCreditThreshold] = useState("");
  const [thresholdPercentage, setThresholdPercentage] = useState("");
  const [tds, setTds] = useState("");
  const [latePaymentFee, setLatePaymentFee] = useState("");
  const [billingCycle, setBillingCycle] = useState("");
  const [paymentDueDate , setPaymentDueDate] = useState("");
  const [bufferDays, setBufferDays] = useState("");
  const [platformFee, setPlatformFee] = useState("");
  const [thresoldValue, setThresoldValue] = useState("");

  useEffect(() => {
    if (selectedRow) {
      setCreditThreshold(selectedRow?.creditThresholdPercent || "");
      setThresholdPercentage(selectedRow?.prepaidWallet?.thresholdPercentage || "");
      setTds(selectedRow?.tds ? `${selectedRow?.tds}%` : "");
      setLatePaymentFee(selectedRow?.latePaymentFeePercent || "");
      setBillingCycle(selectedRow?.billingInfo?.billingCycle || "");
      setPaymentDueDate(selectedRow?.billingInfo?.paymentDuePeriodDays || "");
      setBufferDays(selectedRow?.billingInfo?.bufferDays || "");
      setPlatformFee(selectedRow?.billingInfo?.platformFeePercent || "");
      setThresoldValue(selectedRow?.prepaidWallet?.thresholdCap || "");
    }
  }, [selectedRow]);

  const handleSave = () => {
    const updatedData = {
      _id: selectedRow?._id,
      billingCycle: billingCycle,
      paymentDuePeriodDays: paymentDueDate,
      bufferDays: bufferDays,
      platformFeePercent: Number(platformFee),
      creditThresholdPercent: Number(creditThreshold),
      tds: Number(tds.replace("%", "")), // Remove % if present
      latePaymentFeePercent: Number(latePaymentFee),
      thresholdValue: Number(thresoldValue),
      thresholdPercentage: Number(thresholdPercentage),
    };
    // console.log("updatedData", updatedData);
    onSave(updatedData); // callback to update backend
    onClose();
  };

// console.log("selectedRow", selectedRow);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <Box
        //   sx={{ p: 3 }}
        sx={{
          display: "flex",
          flexDirection: "column",
          height:
            selectedRow?.billingInfo?.billingMode === "POSTPAID"
              ? "80vh"
              : "60vh", // or any suitable height
        }}
      >
        <DialogTitle
          sx={{
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
          //   sx={{
          //     display: "flex",
          //     justifyContent: "space-between",
          //     alignItems: "center",
          //     p: 0,
          //     mb: 2,
          //   }}
        >
          <Typography variant="h4" fontWeight={600}>
            Details
          </Typography>
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              //   color: "navy",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          // sx={{ p: 0 }}
          dividers
          sx={{
            overflowY: "auto",
            flex: 1,
            backgroundColor: "#fafafa", // optional
          }}
        >
        
              <EditableSelectRow
                label="Billing Cycle"
                value={billingCycle}
                onChange={setBillingCycle}
                options={["MONTHLY", "FORTNIGHTLY"]}
              />
  {selectedRow?.billingInfo?.billingMode === "POSTPAID" && (
            <>
              <EditableSelectRow
                label="Payment Due Period"
                value={paymentDueDate}
                onChange={setPaymentDueDate}
                options={["7 days", "15 days", "30 days", "60 days", "90 days"]}
              />

              <EditableSelectRow
                label="Buffer Days"
                value={bufferDays}
                onChange={setBufferDays}
                options={["7 days", "15 days", "30 days", "60 days", "90 days"]}
              />
            </>
          )}

          <KeyValueRow
            label="Convenience Fee (%)"
            value={
              selectedRow?.billingInfo?.serviceFeePercent != null
                ? selectedRow.billingInfo.serviceFeePercent === 0
                  ? "0"
                  : `${selectedRow.billingInfo.serviceFeePercent} %`
                : "NA"
            }
          />

          <EditableRow
            label="Platform Fee (%)"
            value={platformFee}
            onChange={setPlatformFee}
            type="number"
          />

          <Divider sx={{ my: 2 }} />

          {selectedRow?.billingInfo?.billingMode === "POSTPAID" && (
            <>    
              <EditableRow
                label="Credit Threshold (%)"
                value={creditThreshold}
                onChange={setCreditThreshold}
                type="number"
              />

              <EditableSelectRow
                label="TDS (%)"
                value={tds}
                onChange={setTds}
                options={["10%", "2%"]}
              />

              <Divider sx={{ my: 2 }} />

              <EditableRow
                label="Late Payment Fee (%)"
                value={latePaymentFee}
                onChange={setLatePaymentFee}
                type="number"
              />
            </>
          )}

          {selectedRow?.billingInfo?.billingMode === "PREPAID" && (
            <>
             <EditableRow
                label="Threshold Percentage(%)"
                value={thresholdPercentage}
                onChange={setThresholdPercentage}
                type="number"
              />
              <EditableRow
              label="Threshold Cap"
              value={thresoldValue}
              onChange={setThresoldValue}
              type="number"
            />
            </>
            
          )}
        </DialogContent>

        <DialogActions
          // sx={{ justifyContent: "flex-end", mt: 3 }}
          sx={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            zIndex: 10,
            borderTop: "1px solid #e0e0e0",
            justifyContent: "space-between",
            padding: 2,
          }}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
                    backgroundColor: "#fff",
                    color: "#000",
                    borderColor: "#ccc",
                    ":hover": {
                      backgroundColor: "#f5f5f5",
                      borderColor: "#999",
                    },
                  }}
          >
            Close
          </Button>

          <Button
            onClick={handleSave}
            variant="contained"
            sx={{ ml: 2, borderRadius: 2 }}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};


// Static Key:Value Row
const KeyValueRow = ({ label, value }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <Typography sx={{ flex: 1 }} color="text.secondary">
      {label}
    </Typography>
    <Typography sx={{ flex: 1, textAlign: "right" }} fontWeight={500}>
      {value}
    </Typography>
  </Box>
);

// Editable Input Row
const EditableRow = ({ label, value, onChange }) => {
  const handleWheel = (e) => {
    // Prevent scroll from changing the input value
    e.target.blur();
  };

  return (
    <Box display="flex" alignItems="center" mb={2}>
      <Typography sx={{ flex: 1 }} color="text.secondary">
        {label}
      </Typography>
      <TextField
        fullWidth
        type="number"
        value={value}
        // onChange={(e) => onChange(e.target.value)}
        onChange={(e) => {
          const val = e.target.value;
          if (val === "" || (Number(val) >= 0 && Number(val) <= 100)) {
            onChange(val);
          }
        }}
        onWheel={handleWheel}
        sx={{
          flex: 1,
          "& input[type=number]::-webkit-inner-spin-button": {
            display: "none",
          },
          "& input[type=number]::-webkit-outer-spin-button": {
            display: "none",
          },
          "& input[type=number]": {
            MozAppearance: "textfield",
          },
        }}
        inputProps={{
          style: { textAlign: "left" },
        }}
      />
    </Box>
  );
};


// Editable Select Row
const EditableSelectRow = ({ label, value, onChange, options }) => (
  <Box display="flex" alignItems="center" mb={2} sx={{ position: "relative" }}>
    <Typography sx={{ flex: 1 }} color="text.secondary">
      {label}
    </Typography>

    <Box sx={{ flex: 1, position: "relative" }}>
      <Select
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        input={<OutlinedInput />}
        IconComponent={() => null} // prevent default icon
        sx={{
          width: "100%",
          minHeight: "45px",
          "& .MuiSelect-select": {
            minHeight: "45px",
            display: "flex",
            alignItems: "center",
            pr: 4, // space for icon
          },
        }}
      >
        {options.map((opt) => (
          <MenuItem key={opt} value={opt}>
            {opt}
          </MenuItem>
        ))}
      </Select>

      {/* Custom Arrow Icon */}
      <ArrowDropDownIcon
        style={{
          color: "blue",
          position: "absolute",
          top: "50%",
          right: "10px",
          transform: "translateY(-50%)",
          pointerEvents: "none",
        }}
      />
    </Box>
  </Box>
);



export default DetailsDialog;
